import type { ILpElementCtaButton } from 'declarations/contentful';

import { LPLink } from './Buttons';

interface ExtraCtasProps {
  ctas: ILpElementCtaButton[];
}

const ExtraCtas = ({ ctas }: ExtraCtasProps) => {
  return (
    <>
      {ctas.map((cta, idx) => {
        return (
          cta.fields.text &&
          cta.fields.url && (
            <LPLink
              key={idx}
              aria-label={`Go to page ${cta.fields.text}`}
              analyticsName={`cosmos-landing-page-hero-cta-${cta.fields.analyticsId}`}
              ctaStyle={cta.fields.ctaStyle}
              ctaDisplayText={cta.fields.text}
              ctaUrl={cta.fields.url}
            />
          )
        );
      })}
    </>
  );
};

export default ExtraCtas;
